import React, { useState, useEffect, useRef } from 'react';
import styles from './AddBooking.module.css';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import bookingImg from '../../../assets/img/images/bookingimg.png';
import confirmImg from '../../../assets/img/images/confirm3.png';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import colordata from '../../../data/colors.json';
import custom_fields from '../../../data/custom_fields.json';
import {
    ArrowRight,
    Calendar,
    Check,
    CheckCircle,
    X,
} from 'react-feather';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useUser } from '../../../contexts/UserContext';
import Loader from '../Components/Loader';
import moment from 'moment';
import {
    StandaloneSearchBox,
    useLoadScript,
} from '@react-google-maps/api';
import UploadHelper2 from '../../../utils/UploadHelper2';
import { getReadableTextColor } from '../../../utils/colorContrast';
function formatNumber(number) {
    return String(number).padStart(3, '0');
}
function truncateTextByWordCount(text, wordLimit) {
    console.log(text.length);
    if (text.length > wordLimit) {
        return text.slice(0, wordLimit) + '...';
    } else {
        console.log(text);
        return text;
    }
}
const findColorForKey = (key, position) => {
    const item = colordata.find((obj) => obj[key] !== undefined);
    return item ? item[key][position] : '';
};
const getPortalThemeColor = (portal, key, fallback) => {
    return portal && portal.theme_colors && portal.theme_colors[key]
        ? portal.theme_colors[key]
        : fallback;
};
const inputFiledsForKey = (key, position) => {
    console.log(custom_fields);
    const item = custom_fields.find((obj) => obj[key] !== undefined);
    return item ? item[key][position] : [];
};

const AddBooking = () => {
    const [slotsAvailable, setSlotsAvailable] = useState(null);
    const [submit, setSubmit] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState('');
    const [saveloader, setSaveLoader] = useState(false);
    const [selectedServices, setSelectedServices] = useState([]);
    const [paymentResult, setPaymentResult] = useState(null); // 'success' | 'cancelled' | null
    const [paypalCheckout, setPaypalCheckout] = useState(null); // { invoiceId, businessId }
    const paypalButtonsRendered = useRef(false);
    const [invoiceno, setInvoiceno] = useState('001');
    const [pickModal, setPickModal] = useState(false);
    const [modalselected, setModalSelected] = useState(new Date());
    const [monthlySlots, setMonthlySlots] = useState([]);
    const [modalselectedmonth, setModalseletedmonth] = useState(new Date());
    const [loadingmonthlyslots, setLoadingmonthlyslots] = useState(false);
    const [selecteddaySlots, setSelecteddaySlots] = useState([]);
    const [billingadd, setbillingadd] = useState({});
    const [slotsCount, setSlotsDailyCount] = useState([]);
    const [tempSlots, setTempSlots] = useState([]);
    const fullHostname = window.location.hostname;
    const hostnameParts = fullHostname.split('.');
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [addressErrors, setAddressErrors] = useState({});
    const [timeError, setTimeError] = useState('');
    const [initialValues, setInitialValues] = useState({
        firstName: '',
        lastName: '',
        companyName: '',
        email: '',
        phoneNumber: '',
        description: '',
        // pricelist: "",
    });
    var subdomian = hostnameParts[0];
    if (process.env.REACT_APP_TEST_ENV && process.env.REACT_APP_TEST_ENV_SUBDOMAIN) {
        subdomian = process.env.REACT_APP_TEST_ENV_SUBDOMAIN;
    }
    const { user } = useUser();
    const inputRef = useRef();
    const custom_input = inputFiledsForKey(subdomian, 'custom_fields');
    const remove_input = inputFiledsForKey(subdomian, 'remove_fields');
    const required_input = inputFiledsForKey(subdomian, 'required_fields') || [];
    const optional_input = inputFiledsForKey(subdomian, 'optional_fields') || [];
    const bookingPageBackground = getPortalThemeColor(
        user && user.portal,
        'booking_page_background',
        findColorForKey(subdomian, 'secondary2') || '#378CD5'
    );
    const bookingPageTextColor = getReadableTextColor(bookingPageBackground);
    const bookingCardBackground = getPortalThemeColor(
        user && user.portal,
        'booking_form_background',
        findColorForKey(subdomian, 'primary2') || 'white'
    );
    const bookingCardTextColor = getReadableTextColor(bookingCardBackground);
    const isFieldRequired = (key, defaultRequired) => {
        if (remove_input.includes(key)) return false;
        if (optional_input.includes(key)) return false;
        if (required_input.includes(key)) return true;
        return defaultRequired;
    };

    console.log(custom_input, remove_input);
    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: 'AIzaSyB2NVHakbiwVQsxEMJw0LnhwN6C6vuzEZE',
        libraries: ['places'],
    });

    const handlePlaceChanged = () => {
        const [place] = inputRef.current.getPlaces();
        if (place) {
            let country = place.address_components.filter((elem) =>
                elem.types.includes('country')
            );
            let state = place.address_components.filter((elem) =>
                elem.types.includes('administrative_area_level_1')
            );
            let city = place.address_components.filter((elem) =>
                elem.types.includes('locality')
            );
            let street = place.address_components.filter(
                (elem) =>
                    elem.types.includes('street_number') ||
                    elem.types.includes('route') ||
                    elem.types.includes('sublocality')
            );
            let zip = place.address_components.filter((elem) =>
                elem.types.includes('postal_code')
            );
            setbillingadd({
                country: country.length !== 0 ? country[0].long_name : '',
                state: state.length !== 0 ? state[0].long_name : '',
                city: city.length !== 0 ? city[0].long_name : '',
                zip_code: zip.length !== 0 ? zip[0].long_name : '',
                street:
                    street.length !== 0
                        ? street.map((elem) => elem.long_name).join(' ')
                        : '',
            });
        }
    };
    // Derive payment settings from portal data
    const portalPaymentSettings = user && user.portal && user.portal.payment_settings;
    const requirePayment = portalPaymentSettings && portalPaymentSettings.enabled;
    const paymentAvailability = user && user.paymentAvailability;
    const hasAnyGateway = paymentAvailability && (paymentAvailability.has_stripe || paymentAvailability.has_square || paymentAvailability.has_paypal);

    // Handle return from payment checkout
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const paymentParam = params.get('payment');
        if (paymentParam === 'success') {
            setPaymentResult('success');
            setSubmit(true);
        } else if (paymentParam === 'cancelled') {
            setPaymentResult('cancelled');
            setSubmit(true);
        }
    }, []);

    // Load PayPal SDK and render buttons inline (same as invoice.html)
    const paypalContainerCallback = React.useCallback((node) => {
        if (!node || paypalButtonsRendered.current || !paypalCheckout) return;
        var invoiceId = paypalCheckout.invoiceId;
        var businessId = paypalCheckout.businessId;
        var currencyCode = paypalCheckout.currencyCode || 'USD';

        // Step 1: fetch merchant ID from check-invoice (same as invoice.html line 1152)
        fetch('https://bestmate.us/onboard/payments-combined/check-invoice?invoiceId=' + invoiceId)
            .then((res) => res.json())
            .then((result) => {
                var merchantId = result.paypal_account_id;
                if (!merchantId) {
                    console.error('No paypal_account_id found');
                    return;
                }

                // Step 2: load PayPal SDK (same as invoice.html render() function)
                var clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;
                var script = document.createElement('script');
                script.src = 'https://www.paypal.com/sdk/js?client-id=' + clientId + '&merchant-id=' + merchantId + '&currency=' + currencyCode + '&enable-funding=venmo';
                script.onload = function() {
                    if (paypalButtonsRendered.current) return;
                    paypalButtonsRendered.current = true;

                    // Step 3: render buttons (same as invoice.html lines 1094-1145)
                    window.paypal.Buttons({
                        createOrder: (data, actions) => {
                            return fetch("https://bestmate.us/onboard/create-order", {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ invoice_id: invoiceId })
                            })
                            .then((response) => {
                                if (!response.ok) throw new Error('Something went wrong!');
                                return response.json();
                            })
                            .then((order) => {
                                if (order && Object.keys(order).includes("status") && order.status === "CREATED") {
                                    return order.id;
                                } else if (order && Object.keys(order).includes("message")) {
                                    alert(order.message);
                                }
                            }).catch((err) => alert(err.message));
                        },
                        onApprove: (data, actions) => {
                            return fetch("https://bestmate.us/onboard/complete-order", {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ order_id: data.orderID, invoice_business_id: businessId })
                            })
                            .then((response) => {
                                if (!response.ok) throw new Error('Something went wrong!');
                                return response.json();
                            })
                            .then((orderData) => {
                                console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
                                const transaction = orderData.purchase_units[0].payments.captures[0];
                                if (transaction.status === 'COMPLETED') {
                                    setPaymentResult('success');
                                    setPaypalCheckout(null);
                                    setSubmit(true);
                                } else {
                                    alert('Payment status: ' + transaction.status + '. Please try again.');
                                }
                            }).catch((err) => alert('Something went wrong, please contact the business or Bestmate for support'));
                        },
                        onCancel: () => {
                            setPaymentResult('cancelled');
                            setPaypalCheckout(null);
                            setSubmit(true);
                        },
                        onError: (err) => {
                            console.error('PayPal error:', err);
                            alert('Something went wrong. Please try again.');
                        }
                    }).render(node);
                };
                document.head.appendChild(script);
            })
            .catch((err) => {
                console.error('Error fetching check-invoice:', err);
                alert('Could not load payment. Please try again.');
            });
    }, [paypalCheckout]);

    const points = [
        'Interactive demo',
        'Product experts',
        'Flexible times',
        'No sales people',
    ];
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    function generateTimeSlots(startTimeMillis, endTimeMillis, slotDurationMillis = 60 * 60 * 1000) {
        const timeSlots = [];

        const adjustedStartTime = new Date(startTimeMillis);
        if (adjustedStartTime.getMinutes() !== 0) {
            adjustedStartTime.setMinutes(0, 0, 0);
            adjustedStartTime.setHours(adjustedStartTime.getHours() + 1);
        }

        for (
            let currentSlotStart = adjustedStartTime.getTime();
            currentSlotStart + slotDurationMillis <= endTimeMillis;
            currentSlotStart += slotDurationMillis
        ) {
            const slotEnd = currentSlotStart + slotDurationMillis;
            if (startTimeMillis === 1693891800000) {
                console.log(currentSlotStart, startTimeMillis);
                console.log(
                    moment(currentSlotStart).toString(),
                    moment(startTimeMillis).toString()
                );
            }
            if (
                currentSlotStart >= startTimeMillis &&
                slotEnd <= endTimeMillis
            ) {
                const slotStart = new Date(currentSlotStart);
                const slotEndTime = new Date(slotEnd);

                // if (
                //   slotStart.getHours() >= 8 &&
                //   slotStart.getHours() <= 20 // &&
                //   // slotStart.getDay() !== 0 &&
                //   // slotStart.getDay() !== 6
                // ) {
                timeSlots.push({
                    start: slotStart.getTime(),
                    end: slotEndTime.getTime(),
                });
                // }
            }
        }

        return timeSlots;
    }

    function getRandomSlotFromLatestDate(slotsArray) {
        // Group slots by the latest date
        const slotsByDate = slotsArray.reduce((groups, slot) => {
            const slotDate = new Date(slot.start);
            const dateString = slotDate.toDateString();

            if (!groups[dateString]) {
                groups[dateString] = [];
            }

            groups[dateString].push(slot);
            return groups;
        }, {});

        // Select a random slot from each group
        const selectedSlots = [];
        for (const dateGroup of Object.values(slotsByDate)) {
            if (dateGroup.length > 0) {
                const randomIndex = Math.floor(
                    Math.random() * dateGroup.length
                );
                selectedSlots.push(dateGroup[randomIndex]);
            }
        }

        return selectedSlots;
    }

    async function getData(startTime, EndTime, attempt = 0) {
        if (attempt >= 4) {
            setTempSlots((old) => {
                setSlotsAvailable(old.length > 0 ? old.slice(0, 3) : []);
                return old;
            });
            return;
        }
        const fullHostname = window.location.hostname;
        const hostnameParts = fullHostname.split('.');
        var subdomian = hostnameParts[0];
        if (process.env.REACT_APP_TEST_ENV && process.env.REACT_APP_TEST_ENV_SUBDOMAIN) {
            subdomian = process.env.REACT_APP_TEST_ENV_SUBDOMAIN;
        }
        const res = await fetch(
            `https://bestmate.us/portal/findEmptySlots/${subdomian}/${startTime}/${EndTime}`
        );

        if (res.status >= 200 && res.status < 300) {
            let data = await res.json();
            if (
                data &&
                Object.keys(data).length !== 0 &&
                Object.keys(data).includes('emptyTimeSlots') &&
                Object.keys(data.emptyTimeSlots).length !== 0
            ) {
                // Try 1-hour slots first, fall back to 30-minute slots
                let timeSlots = data.emptyTimeSlots
                    .map((elem) => [
                        ...generateTimeSlots(elem.startTime, elem.endTime, 60 * 60 * 1000),
                    ])
                    .flat();

                if (timeSlots.length === 0) {
                    timeSlots = data.emptyTimeSlots
                        .map((elem) => [
                            ...generateTimeSlots(elem.startTime, elem.endTime, 30 * 60 * 1000),
                        ])
                        .flat();
                }

                const selectedSlots = getRandomSlotFromLatestDate(timeSlots);
                const finalSlot = selectedSlots.slice(0, 3);

                if (
                    data &&
                    Object.keys(data).length !== 0 &&
                    Object.keys(data).includes('highestRequestNumber')
                ) {
                    setInvoiceno(data.highestRequestNumber + 1);
                }
                let arr = [];

                setTempSlots((old) => {
                    arr = [...old, ...finalSlot];
                    console.log(arr.length);
                    return arr;
                });
                if (arr.length >= 4) {
                    setSlotsAvailable(arr.slice(0, 3));
                } else {
                    let newstart = EndTime;
                    let newend = moment(newstart).add(7, 'days').valueOf();
                    getData(newstart, newend, attempt + 1);
                }
            } else {
                let newstart = EndTime;
                let newend = moment(newstart).add(7, 'days').valueOf();
                getData(newstart, newend, attempt + 1);
            }
        }
    }
    async function getMonthlySlots(startTime, EndTime) {
        const fullHostname = window.location.hostname;
        const hostnameParts = fullHostname.split('.');
        var subdomian = hostnameParts[0];
        if (process.env.REACT_APP_TEST_ENV && process.env.REACT_APP_TEST_ENV_SUBDOMAIN) {
            subdomian = process.env.REACT_APP_TEST_ENV_SUBDOMAIN;
        }
        console.log('fetching');
        const res = await fetch(
            `https://bestmate.us/portal/findEmptySlots/${subdomian}/${startTime}/${EndTime}`
        );

        if (res.status >= 200 && res.status < 300) {
            let data = await res.json();
            if (
                data &&
                Object.keys(data).length !== 0 &&
                Object.keys(data).includes('emptyTimeSlots') &&
                Object.keys(data.emptyTimeSlots).length !== 0
            ) {
                const timeSlots = data.emptyTimeSlots
                    .map((elem) => [
                        ...generateTimeSlots(elem.startTime, elem.endTime),
                    ])
                    .flat();

                setMonthlySlots(timeSlots);
                setLoadingmonthlyslots(false);
                console.log(new Date(startTime), new Date(EndTime), timeSlots);
            } else {
            }
        }
    }

    useEffect(() => {
        setAddressErrors(prev => Object.keys(prev).length > 0 ? {} : prev);
    }, [billingadd]);

    useEffect(() => {
        if (selectedSlot && timeError) setTimeError('');
    }, [selectedSlot]);

    useEffect(() => {
        // Skip the slow findEmptySlots call when the tenant has removed the
        // "What time works best?" question — no slots are ever shown for them.
        if (remove_input.includes('REQUEST_TIME')) return;
        const startTime = moment(new Date()).valueOf();
        const EndTime = moment(startTime).add(7, 'days').valueOf();
        getData(startTime, EndTime);
    }, []);

    useEffect(() => {
        if (pickModal) {
            console.log('fetching month slot');
            const today = new Date();
            const firstDayOfMonth = new Date(
                today.getFullYear(),
                today.getMonth(),
                1
            );
            const firstDayOfModalselectedMonth = new Date(
                modalselectedmonth.getFullYear(),
                modalselectedmonth.getMonth(),
                1
            );
            const firstDayOfModalselected = new Date(
                modalselected.getFullYear(),
                modalselected.getMonth(),
                1
            );
            console.log(
                firstDayOfMonth.toString(),
                firstDayOfModalselectedMonth.toString(),
                firstDayOfModalselected.toString()
            );
            if (
                firstDayOfMonth.toString() ===
                firstDayOfModalselectedMonth.toString()
                // &&
                // firstDayOfModalselectedMonth.toString() ===
                //   firstDayOfModalselected.toString()
            ) {
                const startTime = moment(new Date()).valueOf();
                const EndTime = moment(
                    new Date(today.getFullYear(), today.getMonth() + 1, 0)
                )
                    .add(1, 'day')
                    .valueOf();
                getMonthlySlots(startTime, EndTime);
            } else {
                const start = new Date(
                    modalselectedmonth.getFullYear(),
                    modalselectedmonth.getMonth(),
                    1
                );
                const startTime = moment(start).valueOf();
                const EndTime = moment(startTime).add(1, 'month').valueOf();
                console.log(modalselectedmonth);
                getMonthlySlots(startTime, EndTime);
            }
        }
    }, [pickModal, modalselectedmonth]);

    useEffect(() => {
        const firstDayOfModalselectedMonth = new Date(
            modalselectedmonth.getFullYear(),
            modalselectedmonth.getMonth(),
            1
        );
        const firstDayOfModalselected = new Date(
            modalselected.getFullYear(),
            modalselected.getMonth(),
            1
        );
        if (
            !loadingmonthlyslots &&
            firstDayOfModalselectedMonth.toString() ===
                firstDayOfModalselected.toString()
        ) {
            let dat = monthlySlots.filter((slot) => {
                const slotDate = new Date(slot.start);
                // console.log(slotDate);
                return (
                    slotDate.getFullYear() === modalselected.getFullYear() &&
                    slotDate.getMonth() === modalselected.getMonth() &&
                    slotDate.getDate() === modalselected.getDate()
                );
            });
            console.log(dat);
            setSelecteddaySlots(dat);
        }
    }, [loadingmonthlyslots, modalselected]);

    const submitHandler = async (elem) => {
        setSaveLoader(true);
        const fullHostname = window.location.hostname;
        const hostnameParts = fullHostname.split('.');
        var subdomian = hostnameParts[0];
        if (process.env.REACT_APP_TEST_ENV && process.env.REACT_APP_TEST_ENV_SUBDOMAIN) {
            subdomian = process.env.REACT_APP_TEST_ENV_SUBDOMAIN;
        }
        let custom_save = [];
        let {
            firstName,
            lastName,
            companyName,
            description,
            email,
            phoneNumber,
            ...extra_fields
        } = elem;
        console.log(extra_fields);
        custom_input.forEach((field, index) => {
            const key = `${field.input_type}${index}`;
            let value = extra_fields[key];
            if (field.input_type !== 'header' && value && value.length !== 0) {
                custom_save.push({
                    title: field.title,
                    input_type: field.input_type === 'single_slider' ? 'short_free_form' : field.input_type,
                    value: field.input_type === 'single_slider' ? String(value) : value,
                });
            }
        });
        console.log(custom_save);
        const partnerData = {
            partner_first_name: capitalizeFirstLetter(elem.firstName),
            partner_last_name: capitalizeFirstLetter(elem.lastName),
            partner_email: elem.email,
            partner_company_name: elem.companyName,
            partner_number: elem.phoneNumber,
            partner_billing_address: {
                street: billingadd.street,
                city: billingadd.city,
                state: billingadd.state,
                zip_code: billingadd.zip_code,
                country: billingadd.country,
            },
            partner_shipping_address: {
                street: billingadd.street,
                city: billingadd.city,
                state: billingadd.state,
                zip_code: billingadd.zip_code,
                country: billingadd.country,
            },
            partner_type: 'LEAD',
            // partner_request: elem.description,
            business_app_name: subdomian,
        };
        console.log(partnerData);
        let partnersave = await fetch('https://bestmate.us/portal/createLead', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(partnerData),
        });
        // console.log(partnersave);
        if (partnersave.status >= 200 && partnersave.status < 300) {
            let json = await partnersave.json();
            console.log(json);
            // Build invoice order and total based on selected service
            let invoiceGrandTotal = 0;
            let invoiceOrder = [];
            if (requirePayment && hasAnyGateway && selectedServices.length > 0) {
                invoiceGrandTotal = selectedServices.reduce((sum, s) => sum + Number(s.price), 0);
                invoiceOrder = selectedServices.map(s => ({
                    item_name: s.title,
                    item_description: s.description || '',
                    item_quantity: 1,
                    item_unit_price: s.price,
                    item_total: s.price,
                }));
            }

            let jobData = {
                // job_send_confirmation: true,
                invoice_currency_code: 'USD',
                invoice_currency_name: 'US Dollar',
                invoice_description: elem.description,
                invoice_created_at: new Date().getTime(),
                invoice_number: formatNumber(invoiceno),
                invoice_partner: {
                    // ...partnerData,
                    ...json,
                },
                invoice_custom_fields: custom_save,
                invoice_partner_id: json.partner_id,

                invoice_partner_type: json.partner_type,
                invoice_title: 'New Request from Portal',
                invoice_visits:
                    selectedSlot && Object.keys(selectedSlot).length !== 0
                        ? [
                              {
                                  appointment_start_time: selectedSlot.start,
                                  appointment_end_time: selectedSlot.end,
                                  appointment_zone_offset: -(
                                      new Date().getTimezoneOffset() * 60
                                  ),
                              },
                          ]
                        : [],
                invoice_workflow_type: 'REQUEST',
                business_app_name: subdomian,
                invoice_zone_offset: -(new Date().getTimezoneOffset() * 60),
                //other fields
                invoice_attachments: [],
                invoice_discount_rate: 0,
                invoice_discount_type: 'percentage',
                invoice_tax_type: 'percentage',
                invoice_grand_total: invoiceGrandTotal,
                invoice_order: invoiceOrder,
                invoice_settled_amount: 0,
                invoice_tax_rate: 0,
            };

            console.log(jobData);
            let jobSave = await fetch(
                'https://bestmate.us/portal/submitRequest',
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(jobData),
                }
            );
            if (jobSave.status >= 200 && jobSave.status < 300) {
                let invoiceResult = await jobSave.json();
                // If payment is required, redirect to checkout
                if (requirePayment && hasAnyGateway && selectedServices.length > 0 && invoiceResult.invoice_id) {
                    const portalOrigin = window.location.origin;
                    const successUrl = encodeURIComponent(`${portalOrigin}/book?payment=success`);
                    const cancelUrl = encodeURIComponent(`${portalOrigin}/book?payment=cancelled`);

                    let checkoutUrl = '';
                    if (paymentAvailability.has_stripe) {
                        checkoutUrl = `https://gobestmate.com/invoice/checkout/${invoiceResult.invoice_id}?success_url=${successUrl}&cancel_url=${cancelUrl}&source=portal`;
                    } else if (paymentAvailability.has_square) {
                        checkoutUrl = `https://gobestmate.com/invoice/square-checkout/${invoiceResult.invoice_id}?success_url=${successUrl}&cancel_url=${cancelUrl}&source=portal`;
                    } else if (paymentAvailability.has_paypal) {
                        // Render PayPal buttons inline (same flow as invoice.html)
                        const grandTotal = selectedServices.reduce((sum, s) => sum + Number(s.price), 0);
                        setPaypalCheckout({
                            invoiceId: invoiceResult.invoice_id,
                            businessId: invoiceResult.invoice_business_id,
                            currencyCode: jobData.invoice_currency_code || 'USD',
                            amount: grandTotal.toFixed(2),
                        });
                        setSaveLoader(false);
                        return;
                    }

                    if (checkoutUrl) {
                        window.location.href = checkoutUrl;
                        return;
                    }
                }
                setSubmit(true);
                setSaveLoader(false);
            } else {
                setSaveLoader(false);
                alert('Something went Wrong!');
                return;
            }

            // let res = await jobSave.json();

            // console.log(res);
        } else {
            setSaveLoader(false);
            alert('Something went Wrong!');
            return;
        }
    };
    // let disabledDays = {
    //   before: new Date(),
    // };
    let disabledDays = (date) => {
        const currentDate = new Date();

        return (
            loadingmonthlyslots ||
            (date.getDate() !== currentDate.getDate() && date < currentDate)
        );
    };

    useEffect(() => {
        if (custom_input && custom_input.length !== 0) {
            let obj = {};
            custom_input.forEach((elem, index) => {
                console.log(elem);
                if (elem.input_type !== 'header') {
                    if (
                        elem.input_type === 'short_free_form' ||
                        elem.input_type === 'long_free_form'
                    ) {
                        obj[`${elem.input_type}${index}`] = '';
                    } else if (
                        elem.input_type === 'multi_select' ||
                        elem.input_type === 'single_select' ||
                        elem.input_type === 'image_upload'
                    ) {
                        obj[`${elem.input_type}${index}`] = [];
                    } else if (
                        elem.input_type === 'single_slider'
                    ) {
                        obj[`${elem.input_type}${index}`] = elem.min ?? 0;
                    }
                }
            });
            console.log(obj);
            setInitialValues((old) => {
                console.log({ ...old, ...obj });
                return { ...old, ...obj };
            });
        }
    }, [custom_input]);

    const validationSchema = () => {
        const schemaFields = {};

        // First name (default required)
        let firstNameSchema = Yup.string().max(
            100,
            `First Name must be less than 100 characters`
        );
        if (isFieldRequired('FIRST_NAME', true)) {
            firstNameSchema = firstNameSchema.required('First Name is required');
        }
        schemaFields.firstName = firstNameSchema;

        // Phone number (default required)
        let phoneSchema = Yup.string().matches(
            /^[0-9+\-\s]+$/,
            'Phone number is not valid'
        );
        if (isFieldRequired('PHONE_NUMBER', true)) {
            phoneSchema = phoneSchema.required('Phone is required');
        }
        schemaFields.phoneNumber = phoneSchema;

        // Email (default required)
        let emailSchema = Yup.string().email('Must be a Valid Email');
        if (isFieldRequired('EMAIL', true)) {
            emailSchema = emailSchema.required('Email is required');
        }
        schemaFields.email = emailSchema;

        // Last name (default required unless removed)
        if (!remove_input.includes('LAST_NAME')) {
            let lastNameSchema = Yup.string().max(
                100,
                `Last Name must be less than 100 characters`
            );
            if (isFieldRequired('LAST_NAME', true)) {
                lastNameSchema = lastNameSchema.required('Last Name is required');
            }
            schemaFields.lastName = lastNameSchema;
        }

        // Company name (default optional)
        if (!remove_input.includes('COMPANY_NAME')) {
            let companySchema = Yup.string();
            if (isFieldRequired('COMPANY_NAME', false)) {
                companySchema = companySchema.required('Company is required');
            }
            schemaFields.companyName = companySchema;
        }

        // Request description (default optional)
        if (!remove_input.includes('REQUEST_DESCRIPTION')) {
            let descSchema = Yup.string();
            if (isFieldRequired('REQUEST_DESCRIPTION', false)) {
                descSchema = descSchema.required('This Input is required');
            }
            schemaFields.description = descSchema;
        }
        custom_input.forEach((field, index) => {
            if (field.input_type !== 'header') {
                const fieldName = `${field.input_type}${index}`;
                let fieldSchema;

                switch (field.input_type) {
                    case 'single_select':
                    case 'multi_select':
                        fieldSchema = Yup.array().of(Yup.string());
                        break;
                    case 'short_free_form':
                    case 'long_free_form':
                        fieldSchema = Yup.string();
                        break;
                    case 'image_upload':
                        fieldSchema = Yup.array().of(
                            Yup.object().shape({
                                image: Yup.string().required(),
                            })
                        );
                        break;
                    default:
                        fieldSchema = Yup.mixed();
                }
                if (!field.optional) {
                    if (field.input_type === 'image_upload') {
                        fieldSchema = fieldSchema
                            .required(`Image is required`)
                            .min(1, `At least one Image is required`);
                    } else if (
                        field.input_type === 'single_select' ||
                        field.input_type === 'multi_select' || 
                        field.input_type === 'single_slider' 
                    ) {
                        fieldSchema = fieldSchema
                            .required(`This Input is required`)
                            .min(1, `At least one option must be selected`);
                    } else {
                        fieldSchema = fieldSchema.required(
                            `This Input is required`
                        );
                    }
                } else if (field.input_type === 'image_upload') {
                    // For optional image uploads, ensure the array exists but can be empty
                    fieldSchema = fieldSchema.default([]);
                }

                schemaFields[fieldName] = fieldSchema;
            }
        });
        return Yup.object().shape(schemaFields);
    };

    return (
        <>
            <div
                className={styles.appbody}
                style={{
                    backgroundColor: bookingPageBackground,
                }}
            >
                <div
                    style={{
                        padding: 32,
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {user.business && user.business.business_logo ? (
                        <div style={{ marginRight: 20 }}>
                            <img
                                style={{ maxHeight: 60, maxWidth: 60 }}
                                src={`${user.business.business_logo}`}
                                alt='Logo'
                            />
                        </div>
                    ) : (
                        <></>
                    )}
                    <div
                        className={styles.logo}
                        style={{
                            wordBreak: 'break-word',
                            color: bookingPageTextColor,
                        }}
                    >
                        {user.business && user.business.business_name
                            ? truncateTextByWordCount(
                                  user.business.business_name,
                                  30
                              )
                            : user.business.business_user_name
                            ? truncateTextByWordCount(
                                  user.business.business_user_name,
                                  30
                              )
                            : 'Business Name'}
                    </div>
                </div>

                {!submit && paypalCheckout ? (
                    <div className={styles.cardContainer}>
                        <Card
                            className='border rounded-2'
                            style={{
                                maxWidth: '500px',
                                width: '100%',
                                marginRight: 20,
                                marginLeft: 20,
                            }}
                        >
                            <Row>
                                <Col>
                                    <div className={styles.secondColumn}>
                                        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#333', marginBottom: 4 }}>
                                            Complete Payment
                                        </h2>
                                        <div style={{ fontSize: 28, fontWeight: 700, color: '#0070ba', marginBottom: 20 }}>
                                            {paypalCheckout.currencyCode} ${paypalCheckout.amount}
                                        </div>
                                        <div ref={paypalContainerCallback} style={{ width: '100%', maxWidth: 350, minHeight: 150 }} />
                                        <div
                                            onClick={() => {
                                                setPaypalCheckout(null);
                                                setSubmit(true);
                                            }}
                                            style={{ marginTop: 16, color: '#666', cursor: 'pointer', fontSize: 14 }}
                                        >
                                            Skip payment
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </div>
                ) : !submit ? (
                    <div className={styles.cardContainer}>
                        {(remove_input.includes('REQUEST_TIME') ||
                            (slotsAvailable && slotsAvailable.length !== 0)) ? (
                            <Card
                                className='border rounded-2'
                                style={{
                                    maxWidth: '880px',
                                    width: '100%',
                                    marginRight: 20,
                                    marginLeft: 20,
                                    backgroundColor: bookingCardBackground,
                                    '--booking-card-text-color':
                                        bookingCardTextColor,
                                }}
                            >
                                <Row>
                                    <Col lg={12}>
                                        <Formik
                                            validationSchema={validationSchema()}
                                            validateOnChange={false}
                                            validateOnBlur={false}
                                            onSubmit={(values) => {
                                                submitHandler(values);
                                            }}
                                            initialValues={initialValues}
                                        >
                                            {({
                                                handleSubmit,
                                                handleChange,
                                                handleBlur,
                                                values,
                                                touched,
                                                isValid,
                                                errors,
                                                dirty,
                                                setFieldValue,
                                                setFieldTouched,
                                                setErrors,
                                            }) => (
                                                <Form
                                                    noValidate
                                                    onSubmit={(event) => {
                                                        event.preventDefault();
                                                        validationSchema()
                                                            .validate(values, {
                                                                abortEarly: false,
                                                            })
                                                            .then(() => {
                                                                // Additional validation for non-Formik fields (address & time)
                                                                const newAddrErrors = {};
                                                                if (isFieldRequired('ADDRESS_STREET', false) && !(billingadd.street || '').trim()) {
                                                                    newAddrErrors.street = 'Street is required';
                                                                }
                                                                if (isFieldRequired('ADDRESS_CITY', false) && !(billingadd.city || '').trim()) {
                                                                    newAddrErrors.city = 'City is required';
                                                                }
                                                                if (isFieldRequired('ADDRESS_STATE', false) && !(billingadd.state || '').trim()) {
                                                                    newAddrErrors.state = 'State is required';
                                                                }
                                                                if (isFieldRequired('ADDRESS_ZIP', false) && !(billingadd.zip_code || '').trim()) {
                                                                    newAddrErrors.zip_code = 'Zip Code is required';
                                                                }
                                                                if (!remove_input.includes('ADDRESS_COUNTRY') && isFieldRequired('ADDRESS_COUNTRY', false) && !(billingadd.country || '').trim()) {
                                                                    newAddrErrors.country = 'Country is required';
                                                                }
                                                                let newTimeError = '';
                                                                if (isFieldRequired('REQUEST_TIME', false) && (!selectedSlot || Object.keys(selectedSlot).length === 0)) {
                                                                    newTimeError = 'Please select a time slot';
                                                                }
                                                                setAddressErrors(newAddrErrors);
                                                                setTimeError(newTimeError);
                                                                // Validate service selection when payment is required
                                                                if (requirePayment && hasAnyGateway && portalPaymentSettings.services && portalPaymentSettings.services.length > 0 && selectedServices.length === 0) {
                                                                    setShowErrorModal(true);
                                                                    return;
                                                                }
                                                                if (Object.keys(newAddrErrors).length > 0 || newTimeError) {
                                                                    setShowErrorModal(true);
                                                                    return;
                                                                }
                                                                // If all validation passes, call handleSubmit
                                                                handleSubmit();
                                                            })
                                                            .catch((err) => {
                                                                console.log(
                                                                    err
                                                                );
                                                                setShowErrorModal(
                                                                    true
                                                                );
                                                                const validationErrors =
                                                                    {};
                                                                err.inner.forEach(
                                                                    (error) => {
                                                                        validationErrors[
                                                                            error.path
                                                                        ] =
                                                                            error.message;
                                                                    }
                                                                );
                                                                console.log(
                                                                    validationErrors,
                                                                    validationSchema()
                                                                );
                                                                // Update errors and touched fields in Formik
                                                                setErrors(
                                                                    validationErrors
                                                                );

                                                                Object.keys(
                                                                    validationErrors
                                                                ).forEach(
                                                                    (key) => {
                                                                        setFieldTouched(
                                                                            key,
                                                                            true,
                                                                            false
                                                                        );
                                                                    }
                                                                );
                                                            });
                                                    }}
                                                    onKeyDown={(event) => {
                                                        if (
                                                            event.key ===
                                                            'Enter'
                                                        ) {
                                                            event.preventDefault(); // Prevent form submit on Enter
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        className={
                                                            styles.firstColumn
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                styles.firstColumnheader
                                                            }
                                                        >
                                                            {subdomian === 'lopezpropertyservices'
                                                                ? 'Free Initial Walkthrough & Estimate Preparation'
                                                                : 'Submit Request'}
                                                        </div>
                                                        <div
                                                            style={{
                                                                marginTop:
                                                                    '40px',
                                                                width: '100%',
                                                                maxWidth: 650,
                                                            }}
                                                        >
                                                            <Row>
                                                                <Col lg={remove_input.includes('LAST_NAME') ? 12 : 6}>
                                                                    <Form.Group className='mb-3'>
                                                                        <Form.Label
                                                                            style={{
                                                                                color: 'black',
                                                                            }}
                                                                            className='m-1'
                                                                        >
                                                                            {remove_input.includes('LAST_NAME') ? 'Name' : 'First Name'}
                                                                            {isFieldRequired('FIRST_NAME', true) && (
                                                                                <span
                                                                                    className='required'
                                                                                    style={{
                                                                                        color: 'red',
                                                                                        marginLeft: 2,
                                                                                    }}
                                                                                >
                                                                                    *
                                                                                </span>
                                                                            )}
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type='text'
                                                                            name='firstName'
                                                                            placeholder={remove_input.includes('LAST_NAME') ? 'Name' : 'First Name'}
                                                                            value={
                                                                                values.firstName
                                                                            }
                                                                            onChange={
                                                                                handleChange
                                                                            }
                                                                            isInvalid={
                                                                                errors.firstName
                                                                            }
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>
                                                                            {
                                                                                errors.firstName
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                                {!remove_input.includes('LAST_NAME') ? (
                                                                <Col lg={6}>
                                                                    <Form.Group className='mb-3'>
                                                                        <Form.Label
                                                                            style={{
                                                                                color: 'black',
                                                                            }}
                                                                            className='m-1'
                                                                        >
                                                                            Last
                                                                            Name
                                                                            {isFieldRequired('LAST_NAME', true) && (
                                                                                <span
                                                                                    className='required'
                                                                                    style={{
                                                                                        color: 'red',
                                                                                        marginLeft: 2,
                                                                                    }}
                                                                                >
                                                                                    *
                                                                                </span>
                                                                            )}
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type='text'
                                                                            name='lastName'
                                                                            placeholder='Last Name'
                                                                            value={
                                                                                values.lastName
                                                                            }
                                                                            onChange={
                                                                                handleChange
                                                                            }
                                                                            isInvalid={
                                                                                errors.lastName
                                                                            }
                                                                            // style={{ padding: "8px" }}
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>
                                                                            {
                                                                                errors.lastName
                                                                            }
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </Row>
                                                            <Form.Group className='mb-3'>
                                                                <Form.Label
                                                                    style={{
                                                                        color: 'black',
                                                                    }}
                                                                    className='m-1'
                                                                >
                                                                    Phone
                                                                    {isFieldRequired('PHONE_NUMBER', true) && (
                                                                        <span
                                                                            className='required'
                                                                            style={{
                                                                                color: 'red',
                                                                                marginLeft: 2,
                                                                            }}
                                                                        >
                                                                            *
                                                                        </span>
                                                                    )}
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type='text'
                                                                    name='phoneNumber'
                                                                    placeholder='Phone'
                                                                    value={
                                                                        values.phoneNumber
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    isInvalid={
                                                                        errors.phoneNumber
                                                                    }
                                                                />
                                                                <Form.Control.Feedback type='invalid'>
                                                                    {
                                                                        errors.phoneNumber
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                            <Form.Group className='mb-3'>
                                                                <Form.Label
                                                                    style={{
                                                                        color: 'black',
                                                                    }}
                                                                    className='m-1'
                                                                >
                                                                    Email
                                                                    {isFieldRequired('EMAIL', true) && (
                                                                        <span
                                                                            className='required'
                                                                            style={{
                                                                                color: 'red',
                                                                                marginLeft: 2,
                                                                            }}
                                                                        >
                                                                            *
                                                                        </span>
                                                                    )}
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type='email'
                                                                    name='email'
                                                                    placeholder='Email'
                                                                    value={
                                                                        values.email
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    isInvalid={
                                                                        errors.email
                                                                    }
                                                                    // style={{ padding: "8px" }}
                                                                />
                                                                <Form.Control.Feedback type='invalid'>
                                                                    {
                                                                        errors.email
                                                                    }
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                            {!remove_input.includes(
                                                                'COMPANY_NAME'
                                                            ) ? (
                                                            <Form.Group className='mb-3'>
                                                                <Form.Label
                                                                    style={{
                                                                        color: 'black',
                                                                    }}
                                                                    className='m-1'
                                                                >
                                                                    Company
                                                                    {isFieldRequired('COMPANY_NAME', false) && (
                                                                        <span
                                                                            className='required'
                                                                            style={{
                                                                                color: 'red',
                                                                                marginLeft: 2,
                                                                            }}
                                                                        >
                                                                            *
                                                                        </span>
                                                                    )}
                                                                </Form.Label>
                                                                <Form.Control
                                                                    type='text'
                                                                    name='companyName'
                                                                    placeholder='Company'
                                                                    value={
                                                                        values.companyName
                                                                    }
                                                                    onChange={
                                                                        handleChange
                                                                    }
                                                                    isInvalid={!!errors.companyName}
                                                                />
                                                                <Form.Control.Feedback type='invalid'>
                                                                    {errors.companyName}
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                            ) : (
                                                                <></>
                                                            )}

                                                            {isLoaded ? (
                                                                <StandaloneSearchBox
                                                                    onLoad={(
                                                                        ref
                                                                    ) =>
                                                                        (inputRef.current =
                                                                            ref)
                                                                    }
                                                                    onPlacesChanged={
                                                                        handlePlaceChanged
                                                                    }
                                                                >
                                                                    <Form.Group className='mb-3'>
                                                                        <Form.Label
                                                                            style={{
                                                                                color: 'black',
                                                                            }}
                                                                            className='m-1'
                                                                        >
                                                                            Address
                                                                            {isFieldRequired('ADDRESS_STREET', false) && (
                                                                                <span
                                                                                    className='required'
                                                                                    style={{
                                                                                        color: 'red',
                                                                                        marginLeft: 2,
                                                                                    }}
                                                                                >
                                                                                    *
                                                                                </span>
                                                                            )}
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type='text'
                                                                            // name="street"
                                                                            placeholder='Street'
                                                                            // value={values.street}
                                                                            // onChange={handleChange}
                                                                            value={
                                                                                billingadd.street
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                setbillingadd(
                                                                                    {
                                                                                        ...billingadd,
                                                                                        street: e
                                                                                            .target
                                                                                            .value,
                                                                                    }
                                                                                )
                                                                            }
                                                                            isInvalid={!!addressErrors.street}
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>
                                                                            {addressErrors.street}
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </StandaloneSearchBox>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            <Row>
                                                                <Col lg={6}>
                                                                    <Form.Group className='mb-3'>
                                                                        <Form.Label
                                                                            style={{ color: 'black' }}
                                                                            className='m-1'
                                                                        >
                                                                            City
                                                                            {isFieldRequired('ADDRESS_CITY', false) && (
                                                                                <span
                                                                                    className='required'
                                                                                    style={{
                                                                                        color: 'red',
                                                                                        marginLeft: 2,
                                                                                    }}
                                                                                >
                                                                                    *
                                                                                </span>
                                                                            )}
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type='text'
                                                                            // name="city"
                                                                            placeholder='City'
                                                                            // value={values.city}
                                                                            // onChange={handleChange}
                                                                            value={
                                                                                billingadd.city
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                setbillingadd(
                                                                                    {
                                                                                        ...billingadd,
                                                                                        city: e
                                                                                            .target
                                                                                            .value,
                                                                                    }
                                                                                )
                                                                            }
                                                                            isInvalid={!!addressErrors.city}
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>
                                                                            {addressErrors.city}
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col lg={6}>
                                                                    <Form.Group className='mb-3'>
                                                                        <Form.Label
                                                                            style={{ color: 'black' }}
                                                                            className='m-1'
                                                                        >
                                                                            State
                                                                            {isFieldRequired('ADDRESS_STATE', false) && (
                                                                                <span
                                                                                    className='required'
                                                                                    style={{
                                                                                        color: 'red',
                                                                                        marginLeft: 2,
                                                                                    }}
                                                                                >
                                                                                    *
                                                                                </span>
                                                                            )}
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type='text'
                                                                            name='state'
                                                                            placeholder='State'
                                                                            // value={values.state}
                                                                            // onChange={handleChange}
                                                                            value={
                                                                                billingadd.state
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                setbillingadd(
                                                                                    {
                                                                                        ...billingadd,
                                                                                        state: e
                                                                                            .target
                                                                                            .value,
                                                                                    }
                                                                                )
                                                                            }
                                                                            isInvalid={!!addressErrors.state}
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>
                                                                            {addressErrors.state}
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg={6}>
                                                                    <Form.Group className='mb-3'>
                                                                        <Form.Label
                                                                            style={{ color: 'black' }}
                                                                            className='m-1'
                                                                        >
                                                                            Zip Code
                                                                            {isFieldRequired('ADDRESS_ZIP', false) && (
                                                                                <span
                                                                                    className='required'
                                                                                    style={{
                                                                                        color: 'red',
                                                                                        marginLeft: 2,
                                                                                    }}
                                                                                >
                                                                                    *
                                                                                </span>
                                                                            )}
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type='text'
                                                                            name='zip'
                                                                            placeholder='Zip Code'
                                                                            // value={values.zip}
                                                                            // onChange={handleChange}
                                                                            value={
                                                                                billingadd.zip_code
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                setbillingadd(
                                                                                    {
                                                                                        ...billingadd,
                                                                                        zip_code:
                                                                                            e
                                                                                                .target
                                                                                                .value,
                                                                                    }
                                                                                )
                                                                            }
                                                                            isInvalid={!!addressErrors.zip_code}
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>
                                                                            {addressErrors.zip_code}
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                                {!remove_input.includes(
                                                                    'ADDRESS_COUNTRY'
                                                                ) ? (
                                                                    <Col lg={6}>
                                                                    <Form.Group className='mb-3'>
                                                                        <Form.Label
                                                                            style={{ color: 'black' }}
                                                                            className='m-1'
                                                                        >
                                                                            Country
                                                                            {isFieldRequired('ADDRESS_COUNTRY', false) && (
                                                                                <span
                                                                                    className='required'
                                                                                    style={{
                                                                                        color: 'red',
                                                                                        marginLeft: 2,
                                                                                    }}
                                                                                >
                                                                                    *
                                                                                </span>
                                                                            )}
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type='text'
                                                                            name='country'
                                                                            placeholder='Country'
                                                                            // value={values.country}
                                                                            // onChange={handleChange}
                                                                            value={
                                                                                billingadd.country
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) =>
                                                                                setbillingadd(
                                                                                    {
                                                                                        ...billingadd,
                                                                                        country:
                                                                                            e
                                                                                                .target
                                                                                                .value,
                                                                                    }
                                                                                )
                                                                            }
                                                                            isInvalid={!!addressErrors.country}
                                                                        />
                                                                        <Form.Control.Feedback type='invalid'>
                                                                            {addressErrors.country}
                                                                        </Form.Control.Feedback>
                                                                    </Form.Group>
                                                                </Col>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            {!remove_input.includes(
                                                                'REQUEST_DESCRIPTION'
                                                            ) ? (
                                                                <Form.Group className='mb-3'>
                                                                    <Form.Label
                                                                        style={{
                                                                            color: 'black',
                                                                        }}
                                                                        className='m-1'
                                                                    >
                                                                        How can
                                                                        we help
                                                                        you?
                                                                        {isFieldRequired('REQUEST_DESCRIPTION', false) && (
                                                                            <span
                                                                                className='required'
                                                                                style={{
                                                                                    color: 'red',
                                                                                    marginLeft: 2,
                                                                                }}
                                                                            >
                                                                                *
                                                                            </span>
                                                                        )}
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type='text'
                                                                        name='description'
                                                                        placeholder='Type Here'
                                                                        as='textarea'
                                                                        rows={4}
                                                                        value={
                                                                            values.description
                                                                        }
                                                                        onChange={
                                                                            handleChange
                                                                        }
                                                                        isInvalid={!!errors.description}
                                                                    />
                                                                    <Form.Control.Feedback type='invalid'>
                                                                        {errors.description}
                                                                    </Form.Control.Feedback>
                                                                </Form.Group>
                                                            ) : (
                                                                <></>
                                                            )}

                                                            </Row>
                                                            {custom_input.map(
                                                                (
                                                                    elem,
                                                                    index
                                                                ) => {
                                                                    let specialName = `${elem.input_type}${index}`;
                                                                    if (
                                                                        elem.input_type ===
                                                                        'header'
                                                                    ) {
                                                                        return (
                                                                            <div
                                                                                className='m-1'
                                                                                style={{
                                                                                    fontWeight:
                                                                                        'bold',
                                                                                    fontSize: 14,
                                                                                    color: 'black',
                                                                                }}
                                                                            >
                                                                                {
                                                                                    elem.title
                                                                                }
                                                                            </div>
                                                                        );
                                                                    } else if (
                                                                        elem.input_type ===
                                                                        'multi_select'
                                                                    ) {
                                                                        return (
                                                                            <Form.Group className='mb-3'>
                                                                                <Form.Label
                                                                                    style={{
                                                                                        color: 'black',
                                                                                    }}
                                                                                    className='m-1'
                                                                                >
                                                                                    {
                                                                                        elem.title
                                                                                    }
                                                                                    {!elem.optional && (
                                                                                        <span
                                                                                            className='required'
                                                                                            style={{
                                                                                                color: 'red',
                                                                                                marginLeft: 2,
                                                                                            }}
                                                                                        >
                                                                                            *
                                                                                        </span>
                                                                                    )}
                                                                                </Form.Label>

                                                                                {elem.data_values.map(
                                                                                    (
                                                                                        option,
                                                                                        index
                                                                                    ) => (
                                                                                        <Form.Check
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                            type='checkbox'
                                                                                            label={
                                                                                                option
                                                                                            }
                                                                                            name={
                                                                                                specialName
                                                                                            }
                                                                                            value={
                                                                                                option
                                                                                            }
                                                                                            checked={values[
                                                                                                specialName
                                                                                            ].includes(
                                                                                                option
                                                                                            )}
                                                                                            style={{
                                                                                                marginLeft: 10,
                                                                                            }}
                                                                                            onChange={(
                                                                                                e
                                                                                            ) => {
                                                                                                const selectedOptions =
                                                                                                    [
                                                                                                        ...values[
                                                                                                            specialName
                                                                                                        ],
                                                                                                    ]; // Copy current selected options
                                                                                                if (
                                                                                                    e
                                                                                                        .target
                                                                                                        .checked
                                                                                                ) {
                                                                                                    // Add option if checked
                                                                                                    selectedOptions.push(
                                                                                                        e
                                                                                                            .target
                                                                                                            .value
                                                                                                    );
                                                                                                } else {
                                                                                                    // Remove option if unchecked
                                                                                                    const indexToRemove =
                                                                                                        selectedOptions.indexOf(
                                                                                                            e
                                                                                                                .target
                                                                                                                .value
                                                                                                        );
                                                                                                    if (
                                                                                                        indexToRemove >
                                                                                                        -1
                                                                                                    ) {
                                                                                                        selectedOptions.splice(
                                                                                                            indexToRemove,
                                                                                                            1
                                                                                                        );
                                                                                                    }
                                                                                                }
                                                                                                // Update Formik field with the new array
                                                                                                setFieldValue(
                                                                                                    specialName,
                                                                                                    selectedOptions
                                                                                                );
                                                                                            }}
                                                                                            isInvalid={
                                                                                                touched[
                                                                                                    specialName
                                                                                                ] &&
                                                                                                !!errors[
                                                                                                    specialName
                                                                                                ]
                                                                                            }
                                                                                        />
                                                                                    )
                                                                                )}
                                                                                <Form.Control.Feedback type='invalid'>
                                                                                    {
                                                                                        errors[
                                                                                            specialName
                                                                                        ]
                                                                                    }
                                                                                </Form.Control.Feedback>
                                                                            </Form.Group>
                                                                        );
                                                                    } else if (
                                                                        elem.input_type ===
                                                                        'single_select'
                                                                    ) {
                                                                        return (
                                                                            <Form.Group className='mb-3'>
                                                                                <Form.Label
                                                                                    style={{
                                                                                        color: 'black',
                                                                                    }}
                                                                                    className='m-1'
                                                                                >
                                                                                    {
                                                                                        elem.title
                                                                                    }
                                                                                    {!elem.optional ? (
                                                                                        <span
                                                                                            className='required'
                                                                                            style={{
                                                                                                color: 'red',
                                                                                                marginLeft: 2,
                                                                                            }}
                                                                                        >
                                                                                            *
                                                                                        </span>
                                                                                    ) : (
                                                                                        <>

                                                                                        </>
                                                                                    )}
                                                                                </Form.Label>
                                                                                {elem.data_values.map(
                                                                                    (
                                                                                        option,
                                                                                        index
                                                                                    ) => (
                                                                                        <Form.Check
                                                                                            key={
                                                                                                index
                                                                                            }
                                                                                            type='radio'
                                                                                            label={
                                                                                                option
                                                                                            }
                                                                                            style={{
                                                                                                marginLeft: 10,
                                                                                            }}
                                                                                            name={
                                                                                                specialName
                                                                                            }
                                                                                            value={
                                                                                                option
                                                                                            }
                                                                                            checked={
                                                                                                values[
                                                                                                    specialName
                                                                                                ] &&
                                                                                                values[
                                                                                                    specialName
                                                                                                ].includes(
                                                                                                    option
                                                                                                )
                                                                                            }
                                                                                            onChange={(
                                                                                                e
                                                                                            ) => {
                                                                                                handleChange(
                                                                                                    {
                                                                                                        target: {
                                                                                                            name: e
                                                                                                                .target
                                                                                                                .name,
                                                                                                            value: [
                                                                                                                e
                                                                                                                    .target
                                                                                                                    .value,
                                                                                                            ],
                                                                                                        },
                                                                                                    }
                                                                                                );
                                                                                            }}
                                                                                            isInvalid={
                                                                                                touched[
                                                                                                    specialName
                                                                                                ] &&
                                                                                                !!errors[
                                                                                                    specialName
                                                                                                ]
                                                                                            }
                                                                                        />
                                                                                    )
                                                                                )}
                                                                                <Form.Control.Feedback type='invalid'>
                                                                                    {
                                                                                        errors[
                                                                                            specialName
                                                                                        ]
                                                                                    }
                                                                                </Form.Control.Feedback>
                                                                            </Form.Group>
                                                                        );
                                                                    } else if (
                                                                      elem.input_type === "single_slider"
                                                                    ) {
                                                                      return (
                                                                        <Form.Group className="mb-3">
                                                                          <Form.Label
                                                                            style={{
                                                                              color: "black",
                                                                            }}
                                                                            className="m-1"
                                                                          >
                                                                            {elem.title}
                                                                            {!elem.optional ? (
                                                                              <span
                                                                                className="required"
                                                                                style={{
                                                                                  color: "red",
                                                                                  marginLeft: 2,
                                                                                }}
                                                                              >
                                                                                *
                                                                              </span>
                                                                            ) : (
                                                                              <></>
                                                                            )}
                                                                          </Form.Label>
                                                                          <div
                                                                            style={{
                                                                              display: "flex",
                                                                              flexDirection: "column",
                                                                              width: "100%",
                                                                              gap: "5px",
                                                                              marginTop: "10px",
                                                                              position: "relative"
                                                                            }}
                                                                          >
                                                                            <div style={{
                                                                              display: "flex",
                                                                              flexDirection: "column",
                                                                              width: "100%",
                                                                              gap: "10px",
                                                                              position: "relative"
                                                                            }}>
                                                                              <div style={{ 
                                                                                position: "relative", 
                                                                                width: "100%",
                                                                                paddingTop: "20px",
                                                                                paddingLeft: "20px",
                                                                                paddingRight: "20px"
                                                                              }}>
                                                                                <span style={{ 
                                                                                  position: "absolute",
                                                                                  top: "0",
                                                                                  left: `calc(${((values[specialName] ?? elem.min) - (elem.min || 0)) / ((elem.max || 100) - (elem.min || 0)) * 100}% + 20px)`,
                                                                                  transform: "translateX(-50%)",
                                                                                  color: "#666",
                                                                                  fontWeight: "bold",
                                                                                  userSelect: "none",
                                                                                  pointerEvents: "none",
                                                                                  whiteSpace: "nowrap",
                                                                                  minWidth: "60px",
                                                                                  textAlign: "center"
                                                                                }}>
                                                                                  {/* {values[specialName] ?? elem.min} {elem.suffix || ''} */}
                                                                                </span>
                                                                                <Form.Range
                                                                                  name={specialName}
                                                                                  value={values[specialName] ?? elem.min}
                                                                                  onChange={(e) => {
                                                                                    handleChange({
                                                                                      target: {
                                                                                        name: specialName,
                                                                                        value: parseInt(e.target.value),
                                                                                      },
                                                                                    });
                                                                                  }}
                                                                                  min={elem.min || 0}
                                                                                  max={elem.max || 100}
                                                                                  step={elem.step || 1}
                                                                                  style={{
                                                                                    background: `linear-gradient(to right, #0173ce ${((values[specialName] ?? elem.min) - (elem.min || 0)) / ((elem.max || 100) - (elem.min || 0)) * 100}%, #dee2e6 ${((values[specialName] ?? elem.min) - (elem.min || 0)) / ((elem.max || 100) - (elem.min || 0)) * 100}%)`,
                                                                                    height: "6px",
                                                                                    borderRadius: "3px"
                                                                                  }}
                                                                                  isInvalid={
                                                                                    touched[specialName] &&
                                                                                    !!errors[specialName]
                                                                                  }
                                                                                />
                                                                              </div>
                                                                              <div style={{
                                                                                display: "flex",
                                                                                justifyContent: "space-between",
                                                                                width: "calc(100% - 40px)",
                                                                                margin: "0 20px",
                                                                                paddingBottom: "20px",
                                                                                position: "relative"
                                                                              }}>
                                                                                {Array.from({ length: ((elem.max || 100) - (elem.min || 0)) / (elem.step || 1) + 1 }, (_, i) => {
                                                                                  const value = (elem.min || 0) + (i * (elem.step || 1));
                                                                                  const position = `${(value - (elem.min || 0)) / ((elem.max || 100) - (elem.min || 0)) * 100}%`;
                                                                                  return (
                                                                                    <span 
                                                                                      key={i} 
                                                                                      style={{ 
                                                                                        position: "absolute",
                                                                                        left: position,
                                                                                        transform: "translateX(-50%)",
                                                                                        color: "#666",
                                                                                        fontSize: "12px",
                                                                                        textAlign: "center",
                                                                                        userSelect: "none",
                                                                                        pointerEvents: "none"
                                                                                      }}
                                                                                    >
                                                                                      {value}
                                                                                    </span>
                                                                                  );
                                                                                })}
                                                                              </div>
                                                                            </div>
                                                                          </div>
                                                                          <Form.Control.Feedback type="invalid">
                                                                            {errors[specialName]}
                                                                          </Form.Control.Feedback>
                                                                        </Form.Group>
                                                                      );
                                                                    } else if (
                                                                        elem.input_type ===
                                                                        'short_free_form'
                                                                    ) {
                                                                        return (
                                                                            <Form.Group className='mb-3'>
                                                                                <Form.Label
                                                                                    style={{
                                                                                        color: 'black',
                                                                                    }}
                                                                                    className='m-1'
                                                                                >
                                                                                    {
                                                                                        elem.title
                                                                                    }
                                                                                    {!elem.optional ? (
                                                                                        <span
                                                                                            className='required'
                                                                                            style={{
                                                                                                color: 'red',
                                                                                                marginLeft: 2,
                                                                                            }}
                                                                                        >
                                                                                            *
                                                                                        </span>
                                                                                    ) : (
                                                                                        <>

                                                                                        </>
                                                                                    )}
                                                                                </Form.Label>
                                                                                <Form.Control
                                                                                    type='text'
                                                                                    name={
                                                                                        specialName
                                                                                    }
                                                                                    placeholder='Type Here'
                                                                                    value={
                                                                                        values[
                                                                                            specialName
                                                                                        ] ||
                                                                                        ''
                                                                                    }
                                                                                    onChange={
                                                                                        handleChange
                                                                                    }
                                                                                    onBlur={
                                                                                        handleBlur
                                                                                    }
                                                                                    isInvalid={
                                                                                        touched[
                                                                                            specialName
                                                                                        ] &&
                                                                                        !!errors[
                                                                                            specialName
                                                                                        ]
                                                                                    }
                                                                                    // style={{ padding: "8px" }}
                                                                                />
                                                                                <Form.Control.Feedback type='invalid'>
                                                                                    {
                                                                                        errors[
                                                                                            specialName
                                                                                        ]
                                                                                    }
                                                                                </Form.Control.Feedback>
                                                                            </Form.Group>
                                                                        );
                                                                    } else if (
                                                                        elem.input_type ===
                                                                        'long_free_form'
                                                                    ) {
                                                                        return (
                                                                            <Form.Group className='mb-3'>
                                                                                <Form.Label
                                                                                    style={{
                                                                                        color: 'black',
                                                                                    }}
                                                                                    className='m-1'
                                                                                >
                                                                                    {
                                                                                        elem.title
                                                                                    }
                                                                                    {!elem.optional && (
                                                                                        <span
                                                                                            className='required'
                                                                                            style={{
                                                                                                color: 'red',
                                                                                                marginLeft: 2,
                                                                                            }}
                                                                                        >
                                                                                            *
                                                                                        </span>
                                                                                    )}
                                                                                </Form.Label>
                                                                                <Form.Control
                                                                                    type='text'
                                                                                    name={
                                                                                        specialName
                                                                                    }
                                                                                    placeholder='Type Here'
                                                                                    as='textarea'
                                                                                    rows={
                                                                                        4
                                                                                    }
                                                                                    value={
                                                                                        values[
                                                                                            specialName
                                                                                        ] ||
                                                                                        ''
                                                                                    }
                                                                                    onChange={
                                                                                        handleChange
                                                                                    }
                                                                                    onBlur={
                                                                                        handleBlur
                                                                                    }
                                                                                    isInvalid={
                                                                                        touched[
                                                                                            specialName
                                                                                        ] &&
                                                                                        !!errors[
                                                                                            specialName
                                                                                        ]
                                                                                    }
                                                                                />
                                                                                <Form.Control.Feedback type='invalid'>
                                                                                    {
                                                                                        errors[
                                                                                            specialName
                                                                                        ]
                                                                                    }
                                                                                </Form.Control.Feedback>
                                                                            </Form.Group>
                                                                        );
                                                                    } else if (
                                                                        elem.input_type ===
                                                                        'image_upload'
                                                                    ) {
                                                                        return (
                                                                            <Form.Group className='mb-3'>
                                                                                <Form.Label
                                                                                    style={{
                                                                                        color: 'black',
                                                                                    }}
                                                                                    className='m-1'
                                                                                >
                                                                                    {
                                                                                        elem.title
                                                                                    }
                                                                                    {!elem.optional && (
                                                                                        <span
                                                                                            className='required'
                                                                                            style={{
                                                                                                color: 'red',
                                                                                                marginLeft: 2,
                                                                                            }}
                                                                                        >
                                                                                            *
                                                                                        </span>
                                                                                    )}
                                                                                </Form.Label>

                                                                                <UploadHelper2
                                                                                    setFieldValue={
                                                                                        setFieldValue
                                                                                    }
                                                                                    currentFiles={
                                                                                        values[
                                                                                            specialName
                                                                                        ]
                                                                                    }
                                                                                    name={
                                                                                        specialName
                                                                                    }
                                                                                />
                                                                            </Form.Group>
                                                                        );
                                                                    } 
                                                                }
                                                            )}

                                                            {!remove_input.includes(
                                                                'REQUEST_TIME'
                                                            ) ? (
                                                                <>
                                                                    <div
                                                                        className={
                                                                            styles.firstColumnheader2
                                                                        }
                                                                    >
                                                                        What
                                                                        time
                                                                        works
                                                                        best?
                                                                    </div>
                                                                    {timeError && (
                                                                        <div style={{ color: 'red', fontSize: 12, marginTop: 4 }}>
                                                                            {timeError}
                                                                        </div>
                                                                    )}
                                                                    <Row
                                                                        style={{
                                                                            display:
                                                                                'flex',
                                                                            width: '100%',
                                                                            justifyContent:
                                                                                'space-between',
                                                                            marginRight: 0,
                                                                            marginLeft: 0,
                                                                            marginTop: 10,
                                                                            // backgroundColor: "red",
                                                                        }}
                                                                    >
                                                                        {slotsAvailable.map(
                                                                            (
                                                                                elem
                                                                            ) => {
                                                                                return (
                                                                                    <Col
                                                                                        style={{
                                                                                            padding: 5,
                                                                                        }}
                                                                                        xs={
                                                                                            6
                                                                                        }
                                                                                        sm={
                                                                                            3
                                                                                        }
                                                                                    >
                                                                                        <div
                                                                                            className={
                                                                                                selectedSlot &&
                                                                                                Object.keys(
                                                                                                    selectedSlot
                                                                                                )
                                                                                                    .length !==
                                                                                                    0 &&
                                                                                                elem.start ===
                                                                                                    selectedSlot.start
                                                                                                    ? styles.selectedtimebox
                                                                                                    : styles.timebox
                                                                                            }
                                                                                            style={{
                                                                                                position:
                                                                                                    'relative',
                                                                                            }}
                                                                                            onClick={() =>
                                                                                                setSelectedSlot(
                                                                                                    elem
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            {selectedSlot &&
                                                                                            Object.keys(
                                                                                                selectedSlot
                                                                                            )
                                                                                                .length !==
                                                                                                0 &&
                                                                                            elem.start ===
                                                                                                selectedSlot.start ? (
                                                                                                <div
                                                                                                    style={{
                                                                                                        backgroundColor:
                                                                                                            '#5CA5E0',
                                                                                                        // padding: 5,
                                                                                                        height: 20,
                                                                                                        width: 20,
                                                                                                        borderRadius: 50,
                                                                                                        display:
                                                                                                            'flex',
                                                                                                        justifyContent:
                                                                                                            'center',
                                                                                                        alignItems:
                                                                                                            'center',
                                                                                                        position:
                                                                                                            'absolute',
                                                                                                        top: -9,
                                                                                                        left: -9,
                                                                                                        // left: 0,
                                                                                                        // marginBottom: 80,
                                                                                                        // marginRight: 150,
                                                                                                    }}
                                                                                                >
                                                                                                    <Check
                                                                                                        size={
                                                                                                            10
                                                                                                        }
                                                                                                        strokeWidth={
                                                                                                            4
                                                                                                        }
                                                                                                        color='white'
                                                                                                    />
                                                                                                </div>
                                                                                            ) : (
                                                                                                <>

                                                                                                </>
                                                                                            )}
                                                                                            <Calendar
                                                                                                size={
                                                                                                    18
                                                                                                }
                                                                                                strokeWidth={
                                                                                                    2
                                                                                                }
                                                                                                className={
                                                                                                    selectedSlot &&
                                                                                                    Object.keys(
                                                                                                        selectedSlot
                                                                                                    )
                                                                                                        .length !==
                                                                                                        0 &&
                                                                                                    elem.start ===
                                                                                                        selectedSlot.start
                                                                                                        ? styles.timeboxiconselected
                                                                                                        : styles.timeboxicon
                                                                                                }
                                                                                            />
                                                                                            <div
                                                                                                style={{
                                                                                                    color: 'black',
                                                                                                    marginTop: 10,
                                                                                                    fontSize:
                                                                                                        '0.75rem',
                                                                                                    fontWeight: 600,
                                                                                                }}
                                                                                            >
                                                                                                {moment(
                                                                                                    new Date(
                                                                                                        elem.start
                                                                                                    )
                                                                                                ).format(
                                                                                                    'dddd'
                                                                                                )}
                                                                                            </div>
                                                                                            <div
                                                                                                style={{
                                                                                                    fontSize:
                                                                                                        '0.75rem',
                                                                                                }}
                                                                                            >
                                                                                                {moment(
                                                                                                    new Date(
                                                                                                        elem.start
                                                                                                    )
                                                                                                ).format(
                                                                                                    'ha'
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col>
                                                                                );
                                                                            }
                                                                        )}
                                                                        <Col
                                                                            style={{
                                                                                padding: 5,
                                                                            }}
                                                                            xs={
                                                                                6
                                                                            }
                                                                            sm={
                                                                                3
                                                                            }
                                                                        >
                                                                            <div
                                                                                className={
                                                                                    selectedSlot &&
                                                                                    Object.keys(
                                                                                        selectedSlot
                                                                                    )
                                                                                        .length !==
                                                                                        0 &&
                                                                                    !slotsAvailable.some(
                                                                                        (
                                                                                            slot
                                                                                        ) =>
                                                                                            slot.start ===
                                                                                                selectedSlot.start &&
                                                                                            slot.end ===
                                                                                                selectedSlot.end
                                                                                    )
                                                                                        ? styles.selectedtimebox
                                                                                        : styles.timebox
                                                                                }
                                                                                style={{
                                                                                    position:
                                                                                        'relative',
                                                                                }}
                                                                                onClick={() => {
                                                                                    setLoadingmonthlyslots(
                                                                                        true
                                                                                    );
                                                                                    setModalseletedmonth(
                                                                                        modalselected
                                                                                    );
                                                                                    setPickModal(
                                                                                        true
                                                                                    );
                                                                                }}
                                                                            >
                                                                                {selectedSlot &&
                                                                                Object.keys(
                                                                                    selectedSlot
                                                                                )
                                                                                    .length !==
                                                                                    0 &&
                                                                                !slotsAvailable.some(
                                                                                    (
                                                                                        slot
                                                                                    ) =>
                                                                                        slot.start ===
                                                                                            selectedSlot.start &&
                                                                                        slot.end ===
                                                                                            selectedSlot.end
                                                                                ) ? (
                                                                                    <div
                                                                                        style={{
                                                                                            backgroundColor:
                                                                                                '#5CA5E0',
                                                                                            // padding: 5,
                                                                                            height: 20,
                                                                                            width: 20,
                                                                                            borderRadius: 50,
                                                                                            display:
                                                                                                'flex',
                                                                                            justifyContent:
                                                                                                'center',
                                                                                            alignItems:
                                                                                                'center',
                                                                                            position:
                                                                                                'absolute',
                                                                                            top: -9,
                                                                                            left: -9,
                                                                                        }}
                                                                                    >
                                                                                        <Check
                                                                                            size={
                                                                                                10
                                                                                            }
                                                                                            strokeWidth={
                                                                                                4
                                                                                            }
                                                                                            color='white'
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <>

                                                                                    </>
                                                                                )}
                                                                                <Calendar
                                                                                    size={
                                                                                        18
                                                                                    }
                                                                                    strokeWidth={
                                                                                        2
                                                                                    }
                                                                                    className={
                                                                                        selectedSlot &&
                                                                                        Object.keys(
                                                                                            selectedSlot
                                                                                        )
                                                                                            .length !==
                                                                                            0 &&
                                                                                        !slotsAvailable.some(
                                                                                            (
                                                                                                slot
                                                                                            ) =>
                                                                                                slot.start ===
                                                                                                    selectedSlot.start &&
                                                                                                slot.end ===
                                                                                                    selectedSlot.end
                                                                                        )
                                                                                            ? styles.timeboxiconselected
                                                                                            : styles.timeboxicon
                                                                                    }
                                                                                />
                                                                                {selectedSlot &&
                                                                                Object.keys(
                                                                                    selectedSlot
                                                                                )
                                                                                    .length !==
                                                                                    0 &&
                                                                                !slotsAvailable.some(
                                                                                    (
                                                                                        slot
                                                                                    ) =>
                                                                                        slot.start ===
                                                                                            selectedSlot.start &&
                                                                                        slot.end ===
                                                                                            selectedSlot.end
                                                                                ) ? (
                                                                                    <>
                                                                                        <div
                                                                                            style={{
                                                                                                color: 'black',
                                                                                                marginTop: 10,
                                                                                                fontSize:
                                                                                                    '0.75rem',
                                                                                                fontWeight: 600,
                                                                                            }}
                                                                                        >
                                                                                            {moment(
                                                                                                new Date(
                                                                                                    selectedSlot.start
                                                                                                )
                                                                                            ).format(
                                                                                                'dddd'
                                                                                            )}
                                                                                        </div>
                                                                                        <div
                                                                                            style={{
                                                                                                fontSize:
                                                                                                    '0.75rem',
                                                                                            }}
                                                                                        >
                                                                                            {moment(
                                                                                                new Date(
                                                                                                    selectedSlot.start
                                                                                                )
                                                                                            ).format(
                                                                                                'ha'
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <div
                                                                                        style={{
                                                                                            color: 'black',
                                                                                            marginTop: 10,
                                                                                            fontSize:
                                                                                                '0.75rem',
                                                                                            textAlign:
                                                                                                'center',
                                                                                            paddingRight: 2,
                                                                                            paddingLeft: 2,
                                                                                            fontSize: 11,
                                                                                            marginTop: 13,
                                                                                        }}
                                                                                    >
                                                                                        I
                                                                                        need
                                                                                        a
                                                                                        different
                                                                                        time
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </Col>
                                                                    </Row>
                                                                    {!isFieldRequired('REQUEST_TIME', false) && (
                                                                    <div
                                                                        className={
                                                                            selectedSlot ===
                                                                            null
                                                                                ? styles.selectedtimebox
                                                                                : styles.timebox
                                                                        }
                                                                        style={{
                                                                            position:
                                                                                'relative',
                                                                            flex: 1,
                                                                            margin: 5,
                                                                            width: 'auto',
                                                                        }}
                                                                        onClick={() =>
                                                                            setSelectedSlot(
                                                                                null
                                                                            )
                                                                        }
                                                                    >
                                                                        {selectedSlot ===
                                                                        null ? (
                                                                            <div
                                                                                style={{
                                                                                    backgroundColor:
                                                                                        '#5CA5E0',
                                                                                    // padding: 5,
                                                                                    height: 20,
                                                                                    width: 20,
                                                                                    borderRadius: 50,
                                                                                    display:
                                                                                        'flex',
                                                                                    justifyContent:
                                                                                        'center',
                                                                                    alignItems:
                                                                                        'center',
                                                                                    position:
                                                                                        'absolute',
                                                                                    top: -9,
                                                                                    left: -9,
                                                                                }}
                                                                            >
                                                                                <Check
                                                                                    size={
                                                                                        10
                                                                                    }
                                                                                    strokeWidth={
                                                                                        4
                                                                                    }
                                                                                    color='white'
                                                                                />
                                                                            </div>
                                                                        ) : (
                                                                            <>

                                                                            </>
                                                                        )}
                                                                        <Calendar
                                                                            size={
                                                                                18
                                                                            }
                                                                            strokeWidth={
                                                                                2
                                                                            }
                                                                            className={
                                                                                selectedSlot ===
                                                                                null
                                                                                    ? styles.timeboxiconselected
                                                                                    : styles.timeboxicon
                                                                            }
                                                                        />
                                                                        <div
                                                                            style={{
                                                                                marginTop: 10,
                                                                                color: 'black',
                                                                                fontSize:
                                                                                    '0.75rem',
                                                                            }}
                                                                        >
                                                                            Schedule
                                                                            Time
                                                                            Later
                                                                        </div>
                                                                    </div>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            {/* Service Selection for paid bookings */}
                                                            {requirePayment && hasAnyGateway && portalPaymentSettings.services && portalPaymentSettings.services.length > 0 && (
                                                                <div style={{ marginTop: 24, marginBottom: 10, width: '100%' }}>
                                                                    <div style={{ color: 'black', fontWeight: 600, fontSize: 14, marginBottom: 10 }}>
                                                                        Select Services
                                                                    </div>
                                                                    <div className={styles.serviceList}>
                                                                        {portalPaymentSettings.services.map((service, idx) => {
                                                                            const isSelected = selectedServices.some(s => s.title === service.title && s.price === service.price);
                                                                            return (
                                                                                <div
                                                                                    key={idx}
                                                                                    onClick={() => {
                                                                                        if (isSelected) {
                                                                                            setSelectedServices(selectedServices.filter(s => !(s.title === service.title && s.price === service.price)));
                                                                                        } else {
                                                                                            setSelectedServices([...selectedServices, service]);
                                                                                        }
                                                                                    }}
                                                                                    className={isSelected ? styles.serviceRowSelected : styles.serviceRow}
                                                                                >
                                                                                    <div className={isSelected ? styles.serviceCheckSelected : styles.serviceCheck}>
                                                                                        {isSelected && <div className={styles.serviceCheckmark}>&#10003;</div>}
                                                                                    </div>
                                                                                    <div className={styles.serviceInfo}>
                                                                                        <div className={styles.serviceTitle}>
                                                                                            {service.title}
                                                                                        </div>
                                                                                        {service.description && (
                                                                                            <div className={styles.serviceDesc}>
                                                                                                {service.description}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                    <div className={styles.servicePrice}>
                                                                                        ${Number(service.price).toFixed(2)}
                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                    {selectedServices.length > 0 && (
                                                                        <div style={{ textAlign: 'right', marginTop: 10, fontWeight: 600, color: '#333', fontSize: 14 }}>
                                                                            Total: ${selectedServices.reduce((sum, s) => sum + Number(s.price), 0).toFixed(2)}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                            <div
                                                                className={
                                                                    styles.submitButtoncont
                                                                }
                                                            >
                                                                <Button
                                                                    className={
                                                                        styles.submitButton
                                                                    }
                                                                    // disabled={!isValid || !dirty}
                                                                    // disabled={!isValid || !dirty}
                                                                    type='save'
                                                                    disabled={
                                                                        saveloader
                                                                    }
                                                                >
                                                                    {!saveloader ? (
                                                                        <>
                                                                            <span>
                                                                                Send
                                                                                Request
                                                                            </span>
                                                                            <ArrowRight
                                                                                size={
                                                                                    16
                                                                                }
                                                                                style={{
                                                                                    marginLeft:
                                                                                        '5px',
                                                                                }}
                                                                            />
                                                                        </>
                                                                    ) : (
                                                                        <div
                                                                            style={{
                                                                                width: 100,
                                                                                display:
                                                                                    'flex',
                                                                                justifyContent:
                                                                                    'center',
                                                                                alignItems:
                                                                                    'center',
                                                                            }}
                                                                        >
                                                                            <Spinner
                                                                                size='sm'
                                                                                animation='border'
                                                                                variant='light'
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Form>
                                            )}
                                        </Formik>
                                    </Col>
                                    {/* <Col lg={4}>
                    <div
                      className={styles.secondColumn}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <img
                          style={{ height: 200, objectFit: "cover" }}
                          src={bookingImg}
                          alt="Contact Image"
                        />
                        <div>
                          See Aha! software in action and get your questions
                          answered
                        </div>
                        <div style={{ width: "100%", marginTop: 20 }}>
                          {points.map((elem) => {
                            return (
                              <div className={styles.points}>
                                <CheckCircle
                                  style={{ marginRight: 15 }}
                                  size={18}
                                  color="#0173CE"
                                />
                                <div
                                  style={{
                                    fontSize: 12,
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {elem}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div style={{ fontSize: 11 }}>Powered by Bestmate</div>
                    </div>
                  </Col> */}
                                </Row>
                            </Card>
                        ) : (
                            <Card
                                className='border rounded-2'
                                style={{
                                    maxWidth: '880px',
                                    height: '500px',
                                    width: '100%',
                                    marginRight: 20,
                                    marginLeft: 20,
                                }}
                            >
                                <Loader />
                            </Card>
                        )}
                    </div>
                ) : (
                    <div className={styles.cardContainer}>
                        <Card
                            className='border rounded-2'
                            style={{
                                maxWidth: '680px',
                                width: '100%',
                                marginRight: 20,
                                marginLeft: 20,
                            }}
                        >
                            <Row>
                                <Col>
                                    <div className={styles.secondColumn}>
                                        <img
                                            style={{
                                                height: 120,
                                                objectFit: 'cover',
                                            }}
                                            src={confirmImg}
                                            alt='Contact Image'
                                        />
                                        <div className={styles.thankstext}>
                                            {paymentResult === 'success'
                                                ? 'Payment Received!'
                                                : 'Thanks for your interest'}
                                        </div>
                                        <div>
                                            {paymentResult === 'success'
                                                ? 'Your booking has been confirmed. Our team will be in touch shortly.'
                                                : 'Our team will be in touch shortly'}
                                        </div>
                                        <div
                                            style={{
                                                width: '100%',
                                                marginTop: 20,
                                            }}
                                        ></div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>
                    </div>
                )}
            </div>
            <Modal
                show={pickModal}
                onHide={() => {
                    setLoadingmonthlyslots(false);
                    // setModalseletedmonth(new Date(modalselected));

                    setPickModal(!pickModal);
                }}
                centered
            >
                <Modal.Body className='text-center'>
                    <div
                        style={{
                            position: 'absolute',
                            right: 10,
                            top: 10,
                        }}
                    >
                        <X
                            size={30}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                setLoadingmonthlyslots(false);
                                setPickModal(!pickModal);
                            }}
                        />
                    </div>
                    <div style={{ minHeight: 500, display: 'flex' }}>
                        <Row style={{ display: 'flex' }}>
                            <Col
                                style={
                                    {
                                        // display: "flex",
                                        // justifyContent: "center",
                                        // alignItems: "center",
                                        // width: "100%",
                                    }
                                }
                            >
                                <div
                                    style={{
                                        maxHeight: 300,
                                        maxWidth: 300,
                                        overflow: 'hidden',
                                    }}
                                >
                                    {loadingmonthlyslots && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                marginLeft: 145,
                                                marginTop: 170,
                                            }}
                                        >
                                            <Spinner
                                                animation='border'
                                                variant='dark'
                                                size='sm'
                                            />
                                        </div>
                                    )}
                                    <div>
                                        <DayPicker
                                            mode='single'
                                            selected={
                                                loadingmonthlyslots
                                                    ? ''
                                                    : modalselected
                                            }
                                            // onSelect={setSelected}
                                            // footer={footer}
                                            // use={renderDay}
                                            className='custom-day-picker'
                                            defaultMonth={modalselected}
                                            fromMonth={new Date()}
                                            onDayClick={(e) => {
                                                setModalSelected(e);
                                                console.log(e);
                                            }}
                                            onMonthChange={(e) => {
                                                setLoadingmonthlyslots(true);
                                                setModalseletedmonth(e);
                                                // setSlotsDailyCount([]);
                                                console.log(e);
                                            }}
                                            styles={
                                                {
                                                    // head_cell: {
                                                    //   width: "60px",
                                                    // },
                                                    // table: {
                                                    //   maxWidth: "100%",
                                                    // },
                                                    // day: {
                                                    //   margin: "auto",
                                                    // },
                                                }
                                            }
                                            disabled={disabledDays}
                                            // modifiers={{
                                            //   emptySlots: (date) => {
                                            //     const dateString = date.toISOString().split("T")[0];
                                            //     console.log(slotsCount, dateString);
                                            //     console.log(slotsCount[dateString]);
                                            //     return slotsCount[dateString]?.length === 0;
                                            //   },
                                            //   currentDate: new Date(),
                                            // }}
                                            // modifiersStyles={{
                                            //   emptySlots: {
                                            //     backgroundColor: "lightgreen",
                                            //   },
                                            //   currentDate: {
                                            //     border: "2px solid pink",
                                            //     position: "relative",
                                            //   },
                                            //   currentDate: {},
                                            // }}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col
                                style={{
                                    width: 400,
                                }}
                            >
                                {/* <div>{loadingmonthlyslots.toString()}</div> */}
                                <div
                                    style={{
                                        padding: 20,
                                        width: '100%',
                                        maxWidth: 300,
                                    }}
                                >
                                    <div style={{ textAlign: 'left' }}>
                                        {moment(new Date(modalselected)).format(
                                            'dddd, MMMM DD'
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            height: '100%',
                                            width: '100%',
                                            overflow: 'scroll',
                                        }}
                                    >
                                        {selecteddaySlots.length !== 0 ? (
                                            selecteddaySlots.map((elem) => (
                                                <div
                                                    className={
                                                        selectedSlot &&
                                                        Object.keys(
                                                            selectedSlot
                                                        ).length !== 0 &&
                                                        elem.start ===
                                                            selectedSlot.start
                                                            ? styles.selectedtimeboxmodal
                                                            : styles.timeboxmodal
                                                    }
                                                    onClick={() => {
                                                        // const endtime = new Date(elem.endtime);
                                                        // endtime.setMinutes(endtime.getMinutes() - 1);
                                                        // const updated = endtime.getTime();
                                                        setSelectedSlot(elem);

                                                        setLoadingmonthlyslots(
                                                            false
                                                        );
                                                        setPickModal(
                                                            !pickModal
                                                        );
                                                    }}
                                                >
                                                    {moment(
                                                        new Date(elem.start)
                                                    ).format('hh:mm A')}
                                                </div>
                                            ))
                                        ) : (
                                            <div
                                                style={{
                                                    fontSize: 12,
                                                    textAlign: 'left',
                                                    marginTop: 10,
                                                    color: '#9c9a9a',
                                                }}
                                            >
                                                No Slots Available
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={showErrorModal}
                onHide={() => setShowErrorModal(false)}
                centered
                size='sm'
            >
                <Modal.Body>
                    <p
                        style={{
                            textAlign: 'center',
                            paddingTop: '10px',
                            paddingBottom: '10px',
                        }}
                    >
                        There are is an error with your submission. Please make
                        sure all required fields are filled out.
                    </p>

                    <Button
                        // variant='secondary'
                        onClick={() => setShowErrorModal(false)}
                        style={{ width: '100%', backgroundColor: '#0173ce' }}
                    >
                        Close
                    </Button>
                </Modal.Body>
            </Modal>
        </>
    );
};
export default AddBooking;
